export default function SectionTriangle() {
  return (
    <div className="absolute top-0 inset-x-0 border-white border-b-primary-50 border-r-primary-50 border-[40px] border-t-[100px] border-r-[100vw] border-b-0 border-l-0" />
  );
}
